import { render, staticRenderFns } from "./SocialInsuranceStandard.vue?vue&type=template&id=896200aa&scoped=true"
import script from "./SocialInsuranceStandard.vue?vue&type=script&lang=js"
export * from "./SocialInsuranceStandard.vue?vue&type=script&lang=js"
import style0 from "./SocialInsuranceStandard.vue?vue&type=style&index=0&id=896200aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896200aa",
  null
  
)

export default component.exports